var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownCaretSmall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45442 3.69105C4.06285 3.38488 3.49722 3.4541 3.19105 3.84566C2.88488 4.23723 2.9541 4.80286 3.34566 5.10903L7.4423 8.3123C7.76791 8.5669 8.22507 8.56699 8.55078 8.31252L12.6507 5.10925C13.0424 4.80323 13.1119 4.23763 12.8059 3.84594C12.4998 3.45426 11.9342 3.38481 11.5425 3.69083L7.99691 6.46101L4.45442 3.69105Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownCaretSmall);
export default __webpack_public_path__ + "static/media/dropdown-caret-small.c68644da62c22e4262311a3417b7f3bb.svg";
export { ForwardRef as ReactComponent };